import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type DeliveryWarehouse as SchemaDeliveryWarehouse } from '../schemas/DeliveryWarehouse';
import { type WarehouseType as SchemaWarehouseType } from '../schemas/WarehouseType';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 */
export const GetDeliveryWarehousesContentType = '' as const;
export type GetDeliveryWarehousesRequest = void;
export type GetDeliveryWarehousesResponses = LinkCommonErrorResponses & {
    /**
     * @description Successful retrieval of data
     */
    '200': {
        'application/json': SchemaDeliveryWarehouse[];
    };
};
export type GetDeliveryWarehousesResponseSuccess = GetDeliveryWarehousesResponses['200']['application/json'];
export type GetDeliveryWarehousesSearchParams = {
    with_archived?: boolean;
    type?: SchemaWarehouseType;
};
export type GetDeliveryWarehousesPathParameters = undefined;
export const GetDeliveryWarehousesUrl = '/delivery/warehouses' as const;
export const GetDeliveryWarehousesMethod = 'GET' as const;
export const getGetDeliveryWarehousesUrl = (_params?: GetDeliveryWarehousesPathParameters) => GetDeliveryWarehousesUrl;
